import React from 'react';

import config from "../config/config";

import IFrame from '../components/iframe';

const iframeURL = `${config.DOMAIN_NAME}/${config.CLIENT_NAME}/website/secure/myaccount.aspx?screen=addresses&resize=true`;

const Addresses = () => {


    return (
        <div className='booking-pathway__account--details--form'>
            <h2 className='booking-pathway__header'>My addresses</h2>

            <div className='customer-details-form'>
                <IFrame url={iframeURL} id="SpektrixAccountIFrame" title="Addresses" hasLoader="true" />
            </div>
        </div>
    );
};

export default Addresses;
